import { render } from "./ClaimsInstructionsHeader.vue?vue&type=template&id=3451d0bb&ts=true"
import script from "./ClaimsInstructionsHeader.vue?vue&type=script&lang=ts"
export * from "./ClaimsInstructionsHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__